import React, { useState } from 'react';
import { useEffect } from 'react';
import { FaCheck } from 'react-icons/fa';
import { toast } from 'react-toastify';
import apiClient from '../../api/apiClient';
import useApi from '../../hooks/useApi';
import MapCustom, {
   PhotoshootMap,
   UserMap,
} from '../../components/maps/MapCustom';

export default () => {
   const [data, setData] = useState({
      invoice: null,
      upload_photo: null,
   });
   const handleChange = (key, value) => {
      setData({ ...data, [key]: value });
   };
   const { request, loading, error } = useApi((formData) =>
      apiClient.post('/photographerJob', formData)
   );

   useEffect(() => {
      const fetch = async () => {
         const response = await apiClient.get('/photographerJob');
         const data = response.data;
         setData(data);
      };
      // fetch();
   }, []);
   const handleSubmit = async (e) => {
      e.preventDefault();
      const formData = new FormData();
      formData.append('invoice', data.invoice);
      formData.append('upload_photo', data.upload_photo);

      const result = await request(formData);
      if (!result.ok) return toast.error('Error');
      toast.success('Campaign Succesfully Created');
   };
   return (
      <div>
         <form onSubmit={handleSubmit}>
            <div className="site-content h-100">
               <div className="p-4">
                  <div className="site-content-body">
                     <div className="container-fluid main_bg_color">
                        <div className="row">
                           <div className="col-md-8 px-md-2">
                              <div>
                                 {/* Carousel */}
                                 <div
                                    id="demo"
                                    className="carousel slide"
                                    data-ride="carousel"
                                 >
                                    {/* The slideshow/carousel */}
                                    <div className="carousel-inner test-2">
                                       <div className="carousel-item active">
                                          <div className="row d-md-flex py-1 slider_border_radius">
                                             <div className="col-md-6 px-2">
                                                <div className="slider_img_height">
                                                   <img
                                                      src={require('../../assets/img/jobs_JustDoIt_img.png')}
                                                      className=" img-fluid h-100 w-100"
                                                      alt=""
                                                   />
                                                </div>
                                             </div>
                                             <div className="col-md-6 px-2">
                                                <div
                                                   className=" slider_line_height "
                                                   style={{ color: 'grey' }}
                                                >
                                                   <div className="d-flex message_dot_Posetion">
                                                      <span className="bottom_line mb-3">
                                                         <h4 className=" mt-2 me-3">
                                                            Driver and Vehicle
                                                            Info.
                                                         </h4>
                                                      </span>
                                                      <div className="posetion">
                                                         <i className="bi bi-chat-left-fill fa-2x my-auto message_color" />
                                                         <i className="bi bi-dot fa-3x dot_posetion" />
                                                      </div>
                                                   </div>
                                                   <p>
                                                      <span className="fw-bold">
                                                         Name:
                                                      </span>
                                                      <span> Ralf Sims</span>
                                                   </p>
                                                   <p>
                                                      <span className="fw-bold">
                                                         Email:
                                                      </span>
                                                      <span>
                                                         ralfsims@gmail.com
                                                      </span>
                                                   </p>
                                                   <p>
                                                      <span className="fw-bold">
                                                         Phone Number:
                                                      </span>
                                                      <span> 123-904-3245</span>
                                                   </p>
                                                   <p>
                                                      <span className="fw-bold">
                                                         Model/Make:
                                                      </span>
                                                      <span>Hino 155</span>
                                                   </p>
                                                   <p>
                                                      <span className="fw-bold">
                                                         Year:
                                                      </span>
                                                      <span>2012</span>
                                                   </p>
                                                   <p>
                                                      <span className="fw-bold">
                                                         License Plate:
                                                      </span>
                                                      <span> GLE623</span>
                                                   </p>
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                       <div className="carousel-item">
                                          <div className="row d-md-flex py-1 slider_border_radius">
                                             <div className="col-md-6 px-2">
                                                <div className="slider_img_height">
                                                   <img
                                                      src={require('../../assets/img/jobs_JustDoIt_img.png')}
                                                      className=" img-fluid h-100 w-100"
                                                      alt=""
                                                   />
                                                </div>
                                             </div>
                                             <div className="col-md-6 px-2">
                                                <div
                                                   className=" slider_line_height "
                                                   style={{ color: 'grey' }}
                                                >
                                                   <span className="bottom_line mb-3">
                                                      <h4 className=" mt-2 me-3">
                                                         Driver and Vehicle
                                                         Info.
                                                      </h4>
                                                   </span>
                                                   <p>
                                                      <span className="fw-bold">
                                                         Name:
                                                      </span>
                                                      <span> Ralf Sims</span>
                                                   </p>
                                                   <p>
                                                      <span className="fw-bold">
                                                         Email:
                                                      </span>
                                                      <span>
                                                         ralfsims@gmail.com
                                                      </span>
                                                   </p>
                                                   <p>
                                                      <span className="fw-bold">
                                                         Phone Number:
                                                      </span>
                                                      <span> 123-904-3245</span>
                                                   </p>
                                                   <p>
                                                      <span className="fw-bold">
                                                         Model/Make:
                                                      </span>
                                                      <span>Hino 155</span>
                                                   </p>
                                                   <p>
                                                      <span className="fw-bold">
                                                         Year:
                                                      </span>
                                                      <span>2012</span>
                                                   </p>
                                                   <p>
                                                      <span className="fw-bold">
                                                         License Plate:
                                                      </span>
                                                      <span> GLE623</span>
                                                   </p>
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                       <div className="carousel-item">
                                          <div className="row d-md-flex py-1 slider_border_radius">
                                             <div className="col-md-6 px-2">
                                                <div className="slider_img_height">
                                                   <img
                                                      src={require('../../assets/img/jobs_JustDoIt_img.png')}
                                                      className=" img-fluid h-100 w-100"
                                                      alt=""
                                                   />
                                                </div>
                                             </div>
                                             <div className="col-md-6 px-2">
                                                <div
                                                   className=" slider_line_height "
                                                   style={{ color: 'grey' }}
                                                >
                                                   <span className="bottom_line mb-3">
                                                      <h4 className=" mt-2 me-3">
                                                         Driver and Vehicle
                                                         Info.
                                                      </h4>
                                                   </span>
                                                   <p>
                                                      <span className="fw-bold">
                                                         Name:
                                                      </span>
                                                      <span> Ralf Sims</span>
                                                   </p>
                                                   <p>
                                                      <span className="fw-bold">
                                                         Email:
                                                      </span>
                                                      <span>
                                                         ralfsims@gmail.com
                                                      </span>
                                                   </p>
                                                   <p>
                                                      <span className="fw-bold">
                                                         Phone Number:
                                                      </span>
                                                      <span> 123-904-3245</span>
                                                   </p>
                                                   <p>
                                                      <span className="fw-bold">
                                                         Model/Make:
                                                      </span>
                                                      <span>Hino 155</span>
                                                   </p>
                                                   <p>
                                                      <span className="fw-bold">
                                                         Year:
                                                      </span>
                                                      <span>2012</span>
                                                   </p>
                                                   <p>
                                                      <span className="fw-bold">
                                                         License Plate:
                                                      </span>
                                                      <span> GLE623</span>
                                                   </p>
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                    <button
                                       className="carousel-control-next carousel_errow"
                                       type="button"
                                       data-bs-target="#demo"
                                       data-bs-slide="next"
                                    >
                                       <i className="bi bi-chevron-right fa-3x right_errow" />
                                    </button>
                                 </div>
                              </div>
                           </div>
                           <div className="col-md-4 px-md-2 mt-md-0 mt-2">
                              <div
                                 className="bg_more_deatils  p-3"
                                 style={{ color: 'grey' }}
                              >
                                 <span className="bottom_line mb-3">
                                    <h5 className>Job Details</h5>
                                 </span>
                                 <p>
                                    <span className="fw-bold">
                                       Number of vehicles:
                                    </span>
                                    <span> 3 Vehicles</span>
                                 </p>
                                 <p>
                                    <span className="fw-bold">Address:</span>
                                    <span>231 Moda Rd., Portland, OR</span>
                                 </p>
                                 <p>
                                    <span className="fw-bold">Shoot Date:</span>
                                    <span>12/14/2022</span>
                                 </p>
                                 <p>
                                    <span className="fw-bold">Shoot Time:</span>
                                    <span>12:00 pm - 5:00 pm</span>
                                 </p>
                              </div>
                           </div>
                        </div>
                        <div className="row">
                           <div className="col-lg-5 col-md-6 px-md-2 my-2">
                              <div className="test-2">
                                 <div className="bg_Map pt-2 pb-3">
                                    <span className="bottom_line ms-3">
                                       <h5 className>Photoshoot locations</h5>
                                    </span>
                                 </div>
                                 <div style={{ width: '100%', height: 350 }}>
                                    <PhotoshootMap />
                                 </div>
                              </div>
                           </div>
                           <div className="col-lg-7 col-md-6">
                              <div className="row">
                                 <div className="col-sm-6 p-2">
                                    <div className="test-2 pt-2 bg-white">
                                       <span className="bottom_line ms-3">
                                          <h5 className>Photo Uploads</h5>
                                       </span>
                                       <form action>
                                          <div className="p-3 text-center">
                                             <div className="text-center mx-lg-4 py-2 img_input_color">
                                                <i className="bi bi-file-earmark-image" />
                                                <br />
                                                <label htmlFor="upload_photo">
                                                   Upload Photo Here
                                                </label>
                                                <input
                                                   onChange={(e) =>
                                                      handleChange(
                                                         'upload_photo',
                                                         e.target.files[0]
                                                      )
                                                   }
                                                   type="file"
                                                   className="form-control"
                                                   hidden
                                                   name
                                                   id="upload_photo"
                                                />
                                             </div>
                                             <img
                                                className="img-fluid w-25"
                                                src={data.upload_photo}
                                                alt=""
                                             />
                                             <p className="lh-lg text-primary">
                                                OR
                                             </p>
                                             <div className="mx-lg-4">
                                                <input
                                                   type="url"
                                                   name
                                                   className="form-control img_input_color"
                                                   placeholder="Input Photo URL here..."
                                                   id
                                                />
                                             </div>
                                             {/* <button className="py-1 mt-2 px-3 rounded-pill upload_submit">Submit</button> */}
                                          </div>
                                       </form>
                                    </div>
                                 </div>
                                 <div className="col-sm-6 p-2">
                                    <div className="test-2 pt-2 bg-white">
                                       <span className="bottom_line ms-3">
                                          <h5 className>Invoice</h5>
                                       </span>
                                       <form action>
                                          <div className="p-3 text-center">
                                             <div className="text-center mx-lg-4 py-2 img_input_color">
                                                <i className="bi bi-file-earmark-fill" />
                                                <br />
                                                <label htmlFor="invoice">
                                                   Upload Here
                                                </label>

                                                <input
                                                   type="file"
                                                   className="form-control"
                                                   hidden
                                                   name
                                                   id="invoice"
                                                   onChange={(e) =>
                                                      handleChange(
                                                         'invoice',
                                                         e.target.files[0]
                                                      )
                                                   }
                                                />
                                             </div>
                                             <img
                                                className="img-fluid w-25"
                                                src={data.invoice}
                                                alt=""
                                             />
                                             <p className="lh-lg text-primary">
                                                OR
                                             </p>
                                             <div className="mx-lg-4">
                                                <input
                                                   type="url"
                                                   name
                                                   className="form-control img_input_color"
                                                   placeholder="Input invoice URL here..."
                                                   id
                                                />
                                             </div>
                                             {/* <button className="py-1 mt-2 px-3 rounded-pill upload_submit">Submit</button> */}
                                          </div>
                                       </form>
                                    </div>
                                 </div>
                                 <div className=" col-sm-6 p-2">
                                    <div className="test-2 bg-white pt-2 h-100">
                                       <span className="bottom_line ms-3">
                                          <h5 className>Photo Guide Sheet</h5>
                                       </span>
                                       <div className="p-3 text-center">
                                          <button className="btn img_input_color px-lg-4 py-2 w-100">
                                             Guide Sheet
                                          </button>
                                       </div>
                                       <p className="text-center mt-4 text-danger">
                                          Report problem with job
                                       </p>
                                    </div>
                                 </div>
                                 <div className="col-sm-6 p-2">
                                    <div className="test-2 pt-2 bg-white">
                                       <span className="bottom_line_note ms-3">
                                          <h5 className>Notes:</h5>
                                       </span>
                                       <textarea
                                          className="form-control note"
                                          rows={5}
                                          id="comment"
                                          defaultValue={''}
                                       />
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div className="select-applies d-flex flex-column align-items-center justify-content-center">
                           <button
                              type="submit"
                              className="btn_bgnone save-changes blue-clr p-3 fs-4 border-0"
                           >
                              <span className="pe-2">Save Changes</span>
                              <FaCheck />
                           </button>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </form>
      </div>
   );
};
